// extracted by mini-css-extract-plugin
export default {"searchButton":"SearchButton_searchButton__Angzq"};